import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "@apps/dashboard/contexts/I18nContext";
import { tryAcceptStoredHouseInvite } from "@apps/dashboard/features/houses/accept-stored-house-invite";
import { getStoredHouseInviteToken } from "@apps/dashboard/lib/house-invite-token";

/**
 * Si hay token de invitación guardado y la sesión ya es válida, intenta unir al hogar al abrir el panel.
 */
export function useAcceptPendingHouseInviteOnShellMount(): void {
  const { locale } = useI18n();
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) {
      return;
    }
    if (!getStoredHouseInviteToken()) {
      return;
    }
    ran.current = true;
    void tryAcceptStoredHouseInvite(locale, navigate).finally(() => {
      // no-op
    });
  }, [locale, navigate]);
}
